import { pgTable, uuid, text, integer, timestamp, jsonb, boolean, index, uniqueIndex } from "drizzle-orm/pg-core";

export const forms = pgTable("forms", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  name: text("name").notNull(),
  slug: text("slug").notNull(),
  status: text("status").default("draft").notNull(),  // draft, published, archived
  fields: jsonb("fields").default([]).notNull(),
  settings: jsonb("settings").default({}).notNull(),
  successMessage: text("success_message"),
  redirectUrl: text("redirect_url"),
  notifyOnSubmission: boolean("notify_on_submission").default(false).notNull(),
  notifyEmails: text("notify_emails").array(),
  privacyNoticeConfig: jsonb("privacy_notice_config"),
  submissionCount: integer("submission_count").default(0).notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_forms_tenant").on(table.tenantId),
  uniqueIndex("idx_forms_slug").on(table.tenantId, table.slug),
]);

export const FORM_STATUSES = ["draft", "published", "archived"] as const;
export type FormStatus = (typeof FORM_STATUSES)[number];

export const contactFormSubmissions = pgTable("contact_form_submissions", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  formId: uuid("form_id").notNull(),
  personId: uuid("person_id"),  // linked after CRM upsert
  data: jsonb("data").default({}).notNull(),
  metadata: jsonb("metadata").default({}).notNull(),
  ipAddressHash: text("ip_address_hash"),  // HMAC-SHA-256 hash (IP_HASH_SECRET) — never raw IP
  userAgent: text("user_agent"),
  source: text("source").default("web").notNull(),  // web, api, embed
  sourceUrl: text("source_url"),
  consentGivenAt: timestamp("consent_given_at", { withTimezone: true }),
  consentVersion: text("consent_version"),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_contact_form_submissions_tenant").on(table.tenantId),
  index("idx_contact_form_submissions_form").on(table.formId),
  index("idx_contact_form_submissions_person").on(table.tenantId, table.personId),
]);
